// Foundation
// id:nameA:nameE:FieldA:FieldE:bsn_no:licence_no:Address:Tel:Mobile:Fax:Email:
// website:Logo:Exchangeval:tax:port:tax_no:BillNotes:BillNotes1:BillNotes2:
// BillNotes3:Disc1_header_ar:Disc2_header_ar:Disc3_header_ar:Disc4_header_ar:
// Disc1_header_en:Disc2_header_en:Disc3_header_en:Disc4_header_en:Disc1_footer_ar:
// Disc2_footer_ar:Disc3_footer_ar:Disc4_footer_ar:Disc1_footer_en:Disc2_footer_en:
// Disc3_footer_en:Disc4_footer_en:MailBox:tax_ats:invval_ats:actv_elec:CustDisc:
// finyear_date1:finyear_date2:showimg:showvat:showdisc:showafterdisc:showtax:
// bank1:acc1:bank2:acc2:bank3:acc3:AddressEn:chkitemquan:msg:offer_type:VAT_Type:
// is_tab3:tab3val:consume_type:img:cnt:img2:contract_no:activity_name:city:branchName:
// sales_man:StartWorkDate:EndWorkDate:CStartWorkDate:CEndWorkDate:firstAlertDate:
// SecondAlertDate:ThirdAlertDate:StopWorkingDate:CStopWorkingDate:is$sys:is$$dessys:
// is$$$dy:server_name:point_name:status_type:computer_type:tax_no_build:
// tax_name_street:tax_name_district:tax_name_city:tax_name_country:tax_zip_code:
// tax_additional_address_no:tax_vat_registration_no:

const elmnts = {
        Foundation:[
          { prop:'nameA',lbl:'unit',tin:0, xs:12,chang:false,auto:[],},
          { prop:'name',lbl:'unit',tin:1, xs:12,chang:false,auto:[],}, 
          { prop:'name',lbl:'unit',tin:2, xs:12,chang:false,auto:[],}, 
          { prop:'name',lbl:'unit',tin:3, xs:12,chang:false,auto:[],}, 
          { prop:'name',lbl:'unit',tin:4, xs:12,chang:false,auto:[],}, 
          { prop:'name',lbl:'unit',tin:5, xs:12,chang:false,auto:[],}, 
          { prop:'name',lbl:'unit',tin:6, xs:12,chang:false,auto:[],}, 
          { prop:'name',lbl:'unit',tin:7, xs:12,chang:false,auto:[],}, 
          { prop:'name',lbl:'unit',tin:8, xs:12,chang:false,auto:[],}, 
          { prop:'name',lbl:'unit',tin:9, xs:12,chang:false,auto:[],}, 
          { prop:'name',lbl:'unit',tin:10, xs:12,chang:false,auto:[],}, 
          { prop:'name',lbl:'unit',tin:11, xs:12,chang:false,auto:[],}, 
          { prop:'name',lbl:'unit',tin:12, xs:12,chang:false,auto:[],}, 
        ],
        Branches:[
          { prop:'name',lbl:'branch-name',tin:0, lg:12, md:12, sm:12, xs:12,chang:false,auto:[],},
          { prop:'Tel',lbl:'telephone',tin:1, lg:4, md:5, sm:5, xs:5,chang:false,auto:[],}, 
          { prop:'Mobile',lbl:'mobile-number',tin:2, lg:5, md:7, sm:7, xs:7,chang:false,auto:[],}, 
          { prop:'Fax',lbl:'fax-number',tin:3, lg:3, md:4, sm:5, xs:4,chang:false,auto:[],}, 
          { prop:'Email',lbl:'email',tin:4, lg:12, md:8, sm:7, xs:8,chang:false,auto:[],}, 
          { prop:'Address',lbl:'address',tin:5, lg:12, md:12, sm:12, xs:12,chang:false,auto:[],}, 
          { prop:'notes',lbl:'notes',tin:6, lg:12, md:12, sm:12, xs:12,chang:false,auto:[],},      
        ],
        Units:[
          { prop:'name',lbl:'unit',tin:0, xs:12,chang:false,
            auto:[], 
          },  
        ],
        Items:[],
        groups:[
          // {prop:'id',lbl:'كود المجموعة',tin:0, xs:12,chang:false,auto:[],},
          {prop:'name',lbl:'product-group',tin:0, xs:12,chang:false,auto:[],},
          {prop:'nameEN',lbl:'group-name-en',tin:1, xs:12,chang:false,auto:[],},
        ],
        tax_groups:[
          // {prop:'id',lbl:'',tin:0, xs:12,chang:false,auto:[],},
          {prop:'nameAR',lbl:'arabic-name',tin:0, xs:12,chang:false,auto:[],},
          {prop:'nameEN',lbl:'english-name',tin:1, xs:8,chang:false,auto:[],},
          {prop:'value',lbl:'value-percent',tin:2, xs:4,chang:false,auto:[],},
        ],
        Safes:[
          // {prop:'id',lbl:'رقم المخزن',tin:0, xs:12,chang:false,auto:[],},
          {prop:'name',lbl:'safe-name',tin:0, xs:12,chang:false,
            auto:
            [
              { prop:'branch',lbl:'branch',ain:0, xs:7,},
              { prop:'status',lbl:'safe-status',ain:1, xs:5,
                //  check:
                //  [
                //   { prop:'IS_Default',lbl:'المخزن الافتراضي',ain:0, xs:5,},
                //  ],
              },
            ],
          },
          {prop:'notes',lbl:'notes',tin:1, xs:12,chang:false,auto:[],},
        ],
        Stocks:[
          // {prop:'id',lbl:'رقم الصندوق',tin:0, xs:12,chang:false,auto:[],},
          {prop:'id',lbl:'account-number',tin:0, xs:4,chang:false,auto:[],},
          {prop:'name',lbl:'stock-name',tin:1, xs:8,chang:false,
            auto:
            [
              { prop:'branch',lbl:'branch',ain:0, xs:7,},
              { prop:'status',lbl:'stock-status',ain:1, xs:5,
                //  check:
                //  [
                //   { prop:'IS_Default',lbl:'الصندوق الافتراضي',ain:0, xs:5,},
                //  ],
              },
            ],
          },
          {prop:'notes',lbl:'notes',tin:2, xs:12,chang:false,auto:[],},
        ],
        Banks:[
          {prop:'id',lbl:'bank-number',tin:0, xs:5,chang:false,
            auto:
            [
              { prop:'acc_type',lbl:'account-type',ain:0, xs:7,},
            ]
          },
          {prop:'name',lbl:'bank-name',tin:1, xs:8,chang:false,auto:[],},
          {prop:'acc_no',lbl:'account-number',tin:2, xs:4,chang:true,
            auto:
            [
              { prop:'country',lbl:'country',ain:1, xs:4,
                  // button:
                  // [{ prop:'',lbl:'',ain:0, xs:5,},]
              },
              { prop:'city',lbl:'city',ain:2, xs:4,
                  // button:
                  // [{ prop:'',lbl:'',ain:0, xs:5,},]
              },
              { prop:'area',lbl:'area',ain:3, xs:4,
                  // button:
                  // [{ prop:'',lbl:'',ain:0, xs:5,},]
              },
            ],
          },
          {prop:'tel',lbl:'telephone',tin:3, xs:5,chang:false,auto:[],},
          {prop:'mobile',lbl:'mobile-number',tin:4, xs:7,chang:false,auto:[],},
          {prop:'notes',lbl:'notes',tin:5, xs:12,chang:false,auto:[],},
        ],
        costcenter:[
          { prop:'Name',lbl:'cost-center',tin:0, xs:12,chang:false,
            auto:[], 
          },  
        ],
        omlat:[
          { prop:'id',lbl:'currency-number',tin:0, xs:5,chang:false,auto:[],}, 
          { prop:'name',lbl:'arabic-name',tin:1, xs:5,chang:false,auto:[],}, 
          { prop:'NameEn',lbl:'currency-latin',tin:2,xs:5,chang:false,auto:[],}, 
          { prop:'omla_desc',lbl:'currency-symbol',tin:3,xs:5,chang:false,auto:[],}, 
          { prop:'exchange',lbl:'exchange-rate',tin:4,xs:5,chang:false,
             auto:
             [
              { prop:'Country',lbl:'country',ain:0, xs:5,}, 
             ],
          },
          { prop:'FakaName',lbl:'fraction-name-ar',tin:5, xs:5,chang:false,auto:[],}, 
          { prop:'FakaNameEn',lbl:'fraction-name-en',tin:6, xs:5,chang:false,
             auto:
              [
               { prop:'oneEqualto',lbl:'one-equals',ain:1, xs:5,}, 
              ],
          },
          { prop:'ITotalFakaD',lbl:'equivalent',tin:7, xs:5,chang:false,auto:[],}, 
          { prop:'symbol',lbl:'description',tin:8, xs:5,chang:false,
              auto:
              [
                { prop:'IS_Active',lbl:'status',ain:2, xs:5,
                  //  check:
                  //   [
                  //     { prop:'IS_Default',lbl:'العملة الافتراضية',cin:0, xs:5,},
                  //     { prop:'is_main',lbl:'العمله المحلية/الرئيسية',cin:1, xs:5,},
                  //   ]
                },
              ],  
          }, 
        ],
        AccountBooks:[
          { prop:'ID',lbl:'book-number',tin:0, xs:5,chang:false,
            auto:[],  
          },  
          { prop:'Name',lbl:'book-name',tin:1, xs:7,chang:false,
            auto:[],  
          }, 
        ],
        Acts:[
          { prop:'name',lbl:'group-name',tin:0, xs:7,chang:false,
            auto:
            [
            { prop:'type',lbl:'group-type',ain:0, xs:5,},
            ]
          },
        ],
        Countries:[
          { prop:'name',lbl:'country-name',tin:0, xs:6,chang:false,
            auto:[]
          },
          { prop:'nationality',lbl:'nationality',tin:1, xs:6,chang:false,
            auto:[]
          },
        ],
        Cities:[
          { prop:'name',lbl:'city-name',tin:0, xs:7,chang:false,
            auto:
            [
            { prop:'country',lbl:'country-name',ain:0, xs:5,},
            ]
          },
        ],
        Areas:[
          { prop:'name',lbl:'area-name',tin:0, xs:7,chang:false,
            auto:
            [
            // { prop:'kkk',lbl:'اسم الدولة',ain:0, xs:6,},
            { prop:'city',lbl:'city-name',ain:0, xs:5,},
            ]
          },
        ],
        Managements:[
          { prop:'name',lbl:'management-name',tin:0, xs:12,chang:false,
            auto:[],
          },  
        ],
        Departments:[
          { prop:'name',lbl:'department-name',tin:0, xs:7,chang:false,
            auto:
            [
              { prop:'manag_id',lbl:'management',ain:0, xs:5,},
            ]
          },
        ],
        jobs:[
          { prop:'name',lbl:'job',tin:0, xs:12,chang:false,
            auto:[], 
          },  
        ],
        CardTypes:[
          { prop:'nameA',lbl:'card-name',tin:0, xs:12,chang:false,
            auto:[],  
          },  
        ],  
}

const elmntall = [
  {},
  {},
  {},
  {
    card:
    [
      {},
      {},
      {},
      {},
      {
        grid:
        [
          { prop:'dateFrom',lbl:'from-date',tin:0, lg:12, md:12, sm:12, xs:12,chang:false,auto:[],},
          { prop:'dateTo',lbl:'to-date',tin:1, lg:4, md:5, sm:5, xs:5,chang:false,
            auto:
            [
              { prop:'branch',lbl:'branch',ain:0, xs:5,},
              { prop:'center',lbl:'cost-center',ain:1, xs:5,},
              { prop:'accno',lbl:'',ain:2, xs:5,},
            ],
          }, 
        ]  
      },
    ]
  },
]

export {elmnts,elmntall};